import { onReactionError } from 'mobx';

import { logToNewRelic } from './debug';

// A cap on what one session can send, should many different reactions keep throwing.
const MAX_REPORTED_MESSAGES = 50;
const reportedMessages = new Set<string>();

// MobX catches an error thrown inside a reaction and only writes it to the console, so New Relic never sees it.
// Imported for its side effect at the top of render.tsx, before any store (module-level ones included) starts a
// reaction. Each distinct message is reported once per session: a reaction that keeps throwing would flood the logs.
onReactionError((error, derivation) => {
  const { message, stack } = error instanceof Error ? error : { message: String(error), stack: undefined };
  if (reportedMessages.has(message) || reportedMessages.size >= MAX_REPORTED_MESSAGES) return;
  reportedMessages.add(message);
  // The cause as attributes, so the JavaScriptError event can be queried by what actually threw.
  logToNewRelic('MobX reaction error', { error, reaction: derivation.name_ }, 'error', {
    causeMessage: message.slice(0, 300),
    causeStack: stack?.slice(0, 1000),
    reaction: derivation.name_,
  });
});
